import {
  CreateWaitMusicApiArg,
  CreateWaitMusicApiResponse,
  DeleteWaitMusicApiArg,
  DeleteWaitMusicApiResponse,
  ReadWaitMusicApiResponse,
  ReadWaitMusicUsageApiArg,
  ReadWaitMusicUsageApiResponse,
} from 'lib-shared-types-api';

import { api } from 'app/app.api';

import { transformWaitMusicCreate } from './utils/transformArg';
import { transformWaitMusicReadResponse } from './utils/transformResponse';

export const waitMusicApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readWaitMusic: builder.query<ReadWaitMusicApiResponse, void>({
      query: () => ({
        version: 1,
        path: 'wait_music',
      }),
      transformResponse: transformWaitMusicReadResponse,
    }),
    createWaitMusic: builder.mutation<
      CreateWaitMusicApiResponse,
      CreateWaitMusicApiArg
    >({
      query: (body) => ({
        version: 1,
        path: 'wait_music',
        method: 'POST',
        body: transformWaitMusicCreate(body),
      }),
    }),
    deleteWaitMusic: builder.mutation<
      DeleteWaitMusicApiResponse,
      DeleteWaitMusicApiArg
    >({
      query: ({ id }) => ({
        version: 1,
        path: `wait_music/${id}`,
        method: 'DELETE',
      }),
    }),
    readWaitMusicUsage: builder.query<
      ReadWaitMusicUsageApiResponse,
      ReadWaitMusicUsageApiArg
    >({
      query: ({ id }) => ({
        version: 1,
        path: `wait_music/${id}/usage`,
      }),
    }),
  }),
});
